export default __webpack_public_path__ + "static/media/logo-footer.e65ba61e.png";